import React, { FC } from 'react'
import { Icon, IconProps } from '@chakra-ui/react'

const Close: FC<IconProps> = (props) => (
  <Icon
    stroke="currentColor"
    viewBox="0 0 14 14"
    // ChakraUIs type definitions clash apparently.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...(props as any)}>
    <path d="M1 1L13 13" strokeMiterlimit="10" strokeWidth="2" />
    <path d="M1 13L13 1" strokeMiterlimit="10" strokeWidth="2" />
  </Icon>
)

// eslint-disable-next-line functional/immutable-data
Close.displayName = 'Close'

export { Close }
